import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'utils/modifiedTranslation';
import { useQuestionnaireData } from '../context';

const useStyles = makeStyles((theme) => ({
  root: ({ small }) => ({
    width: '100%',
    marginBottom: 10,
    fontSize: small ? 18 : 24,
    lineHeight: small ? '26px' : 'inherit',
    [theme.breakpoints.down('sm')]: {
      lineHeight: '26px',
      fontSize: 18,
    },
  }),
}));

/**
 * Title of a question
 */
const QuestionTitle = ({ label, titleClassName }) => {
  const { t } = useTranslation();
  const { embedded } = useQuestionnaireData();
  const classes = useStyles({ small: embedded });

  return (
    <Typography variant="subtitle1" className={`${classes.root} ${titleClassName}`}>
      {t(label)}
    </Typography>
  );
};

QuestionTitle.propTypes = {
  /**
   * Title label
   */
  label: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
};

export default QuestionTitle;
